import React from 'react';

import * as S from './styled';

const CommonStyledLink = ({ children, ...props }) => {
    return <S.StyledLink {...props}>{children}</S.StyledLink>;
};

export default CommonStyledLink;
